export function TotalAnalyticsHeader() {
  return (
    <header className="mb-1">
      <h1 className="m-0 text-2xl font-semibold tracking-tight text-[var(--dash-ink)]">
        Total Analytics
      </h1>
      <p className="m-0 mt-1 text-[13px] text-[var(--dash-muted)]">
        Analytics summary across all campaigns.
      </p>
    </header>
  );
}
